module.exports = __webpack_public_path__ + "img/btn_close.9d62f720.png";